module.exports = __webpack_public_path__ + "img/10 Animation 2-squashed.0edf0d4e.jpg";